<style lang="scss">
.content-wrapper {
  max-width: 1032px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 60px;

  @media (max-width: 960px) {
    margin-top: 32px;
  }
}

$even-img-width: 232px;
$odd-img-width: 312px;
.image-container {
  display: flex;
  justify-content: center;
  height: 232px;

  .even-slider & {
    width: $even-img-width;
  }
  .odd-slider & {
    width: $odd-img-width;
  }
}

.slider-wrapper {
  margin-bottom: 24px;
}
</style>

<template>
  <v-layout column>
    <v-flex v-for="(category, index) in Object.keys(categories)" :key="index" ref="sliders" class="slider-wrapper">
      <slider :class="{'even-slider': index % 2 == 0, 'odd-slider': index % 2 == 1}" :title="category" :images="categories[category]" :index="index" :show-signal="showSlidersControl[index] != undefined && showSlidersControl[index].show" :in-show-queue="showSlidersControl[index] != undefined && showSlidersControl[index].inQueue" :enableHoverLabels="enableHoverLabels">
      </slider>
    </v-flex>
  </v-layout>
</template>

<script>
import Slider from "@/components/images/Slider";

export default {
  props: {
    categories: Object,
    enableHoverLabels: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {
    this.showSlidersControl.splice(Object.keys(this.categories).length);
    this.$nextTick(() => {
      for (var i = 0; i < this.$refs.sliders.length; i++) {
        if (this.shouldShowSlider(this.$refs.sliders[i])) {
          this.showSliderWithTimeout(i);
        }
      }
    });
  },
  methods: {
    showSliderWithTimeout(index) {
      let delay = 100 * this.staggerIndex;
      this.$set(this.showSlidersControl, index, {
        show: false,
        inQueue: true
      });
      setTimeout(() => {
        requestAnimationFrame(() => {
          this.$set(this.showSlidersControl, index, {
            show: true,
            inQueue: false
          });
        });
      }, delay);
      this.staggerIndex = this.staggerIndex + 1;
    },
    shouldShowSlider(el) {
      let bounding = el.getBoundingClientRect();
      let windowHeight = window.innerHeight;
      let topViewThreshold = 100;
      let bottomViewThreshold = windowHeight - 100;
      return (
        bounding.bottom > topViewThreshold && bounding.top < bottomViewThreshold
      );
    }
  },
  computed: {},
  components: {
    Slider
  },
  data() {
    return {
      staggerIndex: 1,
      showBrowseButton: false,
      showSlidersControl: []
    };
  }
};
</script>
